<h1 *ngIf="document && !component">Vložení komponenty EPD</h1>
<h1 *ngIf="document && component">Vložení nové verze komponenty EPD</h1>
<h1 *ngIf="!document && !component">Založení dokumentu EPD</h1>

<fieldset>
  <div class="column-100">
    <gmt-input label="Název dokumentu" [required]="true" *ngIf="!document">
      <input type="text" [(ngModel)]="documentName"/>
    </gmt-input>

    <div *ngIf="document">
      <label>Název dokumentu</label>
      <div class="info">{{ document.name }}</div>
    </div>
  </div>
</fieldset>

<fieldset>
  <legend *ngIf="!component" class="required">Vložení komponenty EPD</legend>
  <legend *ngIf="component" class="required">Vložení nové verze komponenty EPD</legend>

  <div class="column-100">
    <fileupload class="blue" (change)="onFilesChanged($event)" [message]="filesMsg" [errorMsg]="files?.length && !filesValid" inputId="componentHidden"></fileupload>

    <gmt-input *ngIf="!component" label="Typ komponenty" [required]="true">
      <gmt-select
        [optionItems]="attachmentTypes"
        [multiselect]="false"
        [data]="this"
        [itemPipe]="attachmentTypePipe"
        field="attachmentType"
      ></gmt-select>
    </gmt-input>

    <div>
      <label>Poznámka</label>
      <div class="info">
        <div id="add-component-editor"></div>
      </div>
    </div>
  </div>
</fieldset>

<div class="text-center pt-20">
  <gmt-button [clickAction]="onSave" [gmtDisabled]="!isValid()">Uložit</gmt-button>
  <gmt-button [clickAction]="onCancel" class="red">Zrušit</gmt-button>
</div>
